import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { getOnlyDigitsPhone } from '@fttb/common';
export var usePhoneInput = function usePhoneInput(_ref) {
  var isError = _ref.isError,
    errorText = _ref.errorText,
    handleErrorStatus = _ref.handleErrorStatus,
    onChangePhone = _ref.onChangePhone,
    onFocus = _ref.onFocus,
    onErrorAnalytics = _ref.onErrorAnalytics;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setPhoneValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var inputRef = useRef(null);
  useEffect(function () {
    if (inputRef.current && isError) {
      setErrorMessage(errorText || '');
      onErrorAnalytics === null || onErrorAnalytics === void 0 || onErrorAnalytics();
    }
  }, [isError]);
  var validateCtn = function validateCtn() {
    onFocus === null || onFocus === void 0 || onFocus();
    if (value.length === 10 && isError) {
      handleErrorStatus === null || handleErrorStatus === void 0 || handleErrorStatus(false);
      setErrorMessage('');
    }
  };
  var updatePhoneValue = function updatePhoneValue(inputValue) {
    setPhoneValue(inputValue);
    onChangePhone === null || onChangePhone === void 0 || onChangePhone(inputValue);
    validateCtn();
  };
  var handleChange = function handleChange(e) {
    var parsedPhone = getOnlyDigitsPhone(e.target.value);
    updatePhoneValue(parsedPhone);
  };
  var handlePaste = function handlePaste(e) {
    e.preventDefault();
    var pasteData = e.clipboardData.getData('text');
    updatePhoneValue(pasteData.replace(/^(\+7|8)|\D/g, ''));
  };
  return {
    inputRef: inputRef,
    handleFocus: validateCtn,
    errorMessage: errorMessage,
    handleChange: handleChange,
    handlePaste: handlePaste,
    value: value
  };
};